import { render, staticRenderFns } from "./NFCTouchView.vue?vue&type=template&id=5489a25a&scoped=true"
import script from "./NFCTouchView.vue?vue&type=script&lang=js"
export * from "./NFCTouchView.vue?vue&type=script&lang=js"
import style0 from "./NFCTouchView.vue?vue&type=style&index=0&id=5489a25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489a25a",
  null
  
)

export default component.exports